import { BasicEnumerable } from "../BasicEnumerable.js";
export const reverse = (source) => {
    function* iterator() {
        const array = [...source];
        for (let i = array.length - 1; i >= 0; i--) {
            yield array[i];
        }
    }
    return new BasicEnumerable(iterator);
};
